import React from 'react'

type TFooter = {
  readonly flex?: boolean
}

export default function Footer({ flex }: TFooter) {
  const year = new Date().getFullYear()

  return (
    <footer
      className={`${
        flex ? 'flex' : 'fixed'
      } bottom-0 left-0 right-0 mx-auto mt-auto bg-transparent py-4 text-center text-xs text-pop-gray-3`}
    >
      © {year} Responova. All Rights Reserved.
    </footer>
  )
}
